import React from 'react';
import { Typography, Paper, Button, Link as MuiLink } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCampaign } from '../contexts/CampaignContext';

// Card shown at the top of the products page. Driven by the resolved campaign's
// `card` block; renders nothing when there's no card for this page.
const PreorderBanner = () => {
  const theme = useTheme();
  const { card } = useCampaign();

  if (!card) {
    return null;
  }

  const { title, subtitle, body, footnote, ctaUrl, ctaLabel } = card;

  return (
    <Paper
      elevation={16}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 3,
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        mb: 4,
      }}
    >
      {title && (
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1, textAlign: 'center' }}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center', color: theme.palette.text.secondary }}>
          {subtitle}
        </Typography>
      )}
      {body && (
        <Typography variant="body1" sx={{ mb: 1, textAlign: 'center' }}>
          {body}
        </Typography>
      )}
      {footnote && (
        <Typography variant="body2" sx={{ textAlign: 'center', fontWeight: 'bold', color: theme.palette.warning.main }}>
          {footnote}
        </Typography>
      )}
      {ctaUrl && (
        <MuiLink
          href={ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={{ mt: 2 }}
        >
          <Button variant="contained">{ctaLabel || 'Learn more'}</Button>
        </MuiLink>
      )}
    </Paper>
  );
};

export default PreorderBanner;
